module.exports = __webpack_public_path__ + "img/chatbot.ab2f2768.png";